/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultChannel } from '../../models/api-response-paged-result-channel';
import { PagedRequestChannel } from '../../models/paged-request-channel';

export interface SearchChannel$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestChannel
}

export function searchChannel(http: HttpClient, rootUrl: string, params: SearchChannel$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultChannel>> {
  const rb = new RequestBuilder(rootUrl, searchChannel.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultChannel>;
    })
  );
}

searchChannel.PATH = '/v1/api/ui/channel/search';
